import "./StatusPage.css";
import { useEffect, useState } from "react";
import axios from "../axios.jsx";
import Cookies from "js-cookie";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function StatusPage() {
  const [applicationId, setApplicationId] = useState("bhchsdbhjb ");
  const [fullName, setFullName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [photo, setPhoto] = useState();
  const [statusPaymentDetails, setStatusPaymentDetails] = useState(false);
  const [statusPersonalDetails, setStatusPersonalDetails] = useState(false);
  const [statusPhdDetails, setStatusPhdDetails] = useState(false);
  const [statusSubmitted, setStatusSubmitted] = useState(false);
  const [statusPlagairismVerified, setStatusPlagairismVerified] =
    useState(0);
  const [statusPaymentVerified, setStatusPaymentVerified] = useState(0);
  const [statusApplicationVerified, setStatusApplicationVerified] =
    useState(0);
  const [statusCertified, setCertified] = useState(0);
  const [rejected, setRejected] = useState(false);
  const [reasonRejected, setReasonRejected] = useState("");
  axios.defaults.xsrfCookieName = "csrftoken";
  axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

  setInterval(() => {
    if (!Cookies.get("userInfo")) {
      logout();
    }
  }, 1000);

  useEffect(() => {
    async function fetchData() {
      try {
        var reqData = {
          mobile: Cookies.get('username')
        };
        const resData = await axios.post("/api/get-application-details", reqData);
        if (resData.status === 200) {
          const data = resData.data;
          setFullName(data.name);
          setApplicationId(data.id);
          setMobile(data.mobile);
          if (data.application_status === "payment") {
            setStatusPaymentDetails(true);
          } else if (data.application_status === "personal") {
            setStatusPaymentDetails(true);
            setStatusPersonalDetails(true);
          } else if (data.application_status === "submitted") {
            setStatusPaymentDetails(true);
            setStatusPersonalDetails(true);
            setStatusPhdDetails(true);
            setStatusSubmitted(true);
          }
          if (data.verification_status === "initial") {

          }
          else if (data.verification_status === "plagiarism") {
            setStatusPlagairismVerified(1);
          } else if (data.verification_status === "payment") {
            setStatusPlagairismVerified(1);
            setStatusPaymentVerified(1);
          } else if (data.verification_status === "certified") {
            setStatusPlagairismVerified(1);
            setStatusPaymentVerified(1);
            setStatusApplicationVerified(1);
            setCertified(1);
          }
          else {
            setRejected(true);
            setReasonRejected(data.reason);
            var arr = data.verification_status.split(' ');
            if (arr[0] === "initial")
              setStatusPlagairismVerified(-1);
            if (arr[0] === "plagiarism") {
              setStatusPlagairismVerified(1);
              setStatusPaymentVerified(-1);
              setStatusApplicationVerified(0);
            }
            if (arr[0] === "payment") {
              setStatusPlagairismVerified(1);
              setStatusPlagairismVerified(1);
              setStatusPaymentVerified(1);
              setStatusApplicationVerified(-1);
              setCertified(-1);
            }
          }
          try {
            reqData = {
              mobile: Cookies.get('username')
            }
            const resData = await axios.post("/api/get-candidate-details", reqData);
            if (resData.status === 200) {
              const data = resData.data;
              setFatherName(data.father_name);
              setEmail(data.email);
              setPhoto(axios.defaults.baseURL + "api" + data.photo);
            }
          } catch (e) {
            console.log("candiate details not entered");
          }
        }
      } catch (e) {
        alert("can't get details try login again");
        console.log(e);
        logout();
      }
    }
    fetchData();
  }, []);
  function handleStartFilling() {
    window.location = "/application";
  }

  const HandleGenerateCertificate = () => {
    navigate("/certificate", { state: { mobile } });
  }

  const handlePassChange = () => {
    navigate("/forgot-password", { state: { mobile } });
  };

  const navigate = useNavigate();

  return (
    <>
      <br />
      <div className="container">
        <div className="top-left">
          <center>
            <br />
            <img src={photo} className="avatar" alt="candidate_photo" />
            <br />
            <label className="heading">{fullName}</label>
            <div className="profile-details">
              <table className="top-table">
                <tbody>
                  <tr>
                    <td>
                      <label>Application Id</label>
                    </td>
                    <td>
                      <label>{applicationId}</label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Full Name</label>
                    </td>
                    <td>
                      <label>{fullName}</label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Father Name</label>
                    </td>
                    <td>
                      <label>{fatherName}</label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Mobile</label>
                    </td>
                    <td>
                      <label>{mobile}</label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>E-Mail</label>
                    </td>
                    <td>
                      <label>{email}</label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Button className="ms-2 mt-4" onClick={logout}>
              Logout
            </Button>
            <br />
            <Button className="ms-2 mt-4" onClick={handlePassChange}>
              Change Password
            </Button>
          </center>
          <br />
        </div>
        <div className="top-right">
          <label className="heading">Application Status</label>
          <div class="row">
            <div class="hh-grayBox pt45 pb20">
              <div class="row justify-content-between">
                <div
                  class={
                    statusPaymentDetails
                      ? "order-tracking completed"
                      : "order-tracking"
                  }
                >
                  <span class="is-complete"></span>
                  <p>
                    Payment details
                    <br />
                    {/* <span>Mon, June 24</span> */}
                  </p>
                </div>
                <div
                  class={
                    statusPersonalDetails
                      ? "order-tracking completed"
                      : "order-tracking"
                  }
                >
                  <span class="is-complete"></span>
                  <p>
                    Personal details
                    <br />
                    {/* <span>Tue, June 25</span> */}
                  </p>
                </div>
                <div
                  class={
                    statusPhdDetails
                      ? "order-tracking completed"
                      : "order-tracking"
                  }
                >
                  <span class="is-complete"></span>
                  <p>
                    Ph.D. details
                    <br />
                    {/* <span>Fri, June 28</span> */}
                  </p>
                </div>
                <div
                  class={
                    statusSubmitted
                      ? "order-tracking completed"
                      : "order-tracking"
                  }
                >
                  <span class="is-complete"></span>
                  <p>
                    Submitted
                    <br />
                    {/* <span>Fri, June 28</span> */}
                  </p>
                </div>
              </div>
              <br />
              {!statusSubmitted && (
                <span id="apply-button">
                  <i style={{color: "red"}}>Important</i><br />
                  <a href="/instructions" ><Button>Instructions for Scholars</Button></a><br /><br />
                  <Button onClick={handleStartFilling}>
                    Start filling Application
                  </Button>
                </span>
              )}
            </div>
          </div>
          <label className="heading">Verification Status</label>
          <div class="row">
            <div class="hh-grayBox pt45 pb20">
              <div class="row justify-content-between">
                <div
                  class={
                    statusPlagairismVerified >= 0 ?
                      (statusPlagairismVerified === 1 ? "order-tracking completed" : "order-tracking") : "order-tracking rejected"
                  }
                >
                  <span class="is-complete"></span>
                  <p>
                    Plagairism
                    <br />
                    {/* <span>Mon, June 24</span> */}
                  </p>
                </div>
                <div
                  class={
                    statusPaymentVerified >= 0 ?
                      (statusPaymentVerified === 1 ? "order-tracking completed" : "order-tracking") : "order-tracking rejected"
                  }
                >
                  <span class="is-complete"></span>
                  <p>
                    Payment
                    <br />
                    {/* <span>Tue, June 25</span> */}
                  </p>
                </div>
                <div
                  class={
                    statusApplicationVerified >= 0 ?
                      (statusApplicationVerified === 1 ? "order-tracking completed" : "order-tracking") : "order-tracking rejected"
                  }
                >
                  <span class="is-complete"></span>
                  <p>
                    Application
                    <br />
                    {/* <span>Fri, June 28</span> */}
                  </p>
                </div>
                <div
                  class={
                    statusCertified >= 0 ?
                      (statusCertified === 1 ? "order-tracking completed" : "order-tracking") : "order-tracking rejected"
                  }
                >
                  <span class="is-complete"></span>
                  <p>
                    Certified
                    <br />
                    {/* <span>Fri, June 28</span> */}
                  </p>
                </div>
              </div>
              <br />
              {statusCertified === 1 && (
                <span id="apply-button">
                  <Button onClick={HandleGenerateCertificate}>Generate Certificate</Button>
                </span>
              )}

              {rejected && (
                <>
                  <label className="heading">Reason for Rejection: </label>
                  <span className="heading reason-reject">
                    {reasonRejected}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <br />
    </>
  );
}

function logout() {
  window.localStorage.clear();
  Cookies.remove("username");
  Cookies.remove("userInfo");
  window.location.href = "/";
}
